module.exports = __webpack_public_path__ + "static/img/role2.4f1bc54.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/index1/role2.png
// module id = uLPj
// module chunks = 7